import React from 'react';
import { CellProps } from 'react-table';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import classNames from 'classnames';
import styles from '../assets/vendor-actions.module.scss';
import { IVendor } from 'src/types/vendor';
import DeleteVendorAction from './DeleteVendorAction';

const VendorActionsColumn: React.FunctionComponent<CellProps<IVendor>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IVendor>) => {
    return (
        <div className={classNames(styles.actions)}>
            <Link to={Router.generate(routes.VENDOR_EDIT, { id: original.id })} className="btn btn-info">
                <FontAwesomeIcon icon={faPencilAlt} />
            </Link>
            <DeleteVendorAction data={original} />
        </div>
    );
};

export default VendorActionsColumn;
